import {hot} from 'react-hot-loader/root'
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {v4 as uuidv4}  from 'uuid'
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import moment from 'moment'

import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'
const boxTypes = [
  {label:'FEDEX ENVELOPE', value:"FEDEX_ENVELOPE"},
  {label:'FEDEX SMALL BOX', value:"FEDEX_SMALL_BOX"},
  {label:'FEDEX MEDIUM BOX', value:"FEDEX_MEDIUM_BOX"},
  {label:'FEDEX LARGE BOX', value:"FEDEX_LARGE_BOX"},
  {label:'FEDEX EXTRA LARGE BOX', value:"FEDEX_EXTRA_LARGE_BOX"},
  {label:'FEDEX PAK', value:"FEDEX_PAK"},
  {label:'FEDEX TUBE', value:"FEDEX_TUBE"}
 ]

import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList} from 'util/Utils';
import AdminSettingsListTable from 'dashboard/settings/AdminSettingsListTable';
import AdminSettingsSearchBox from 'dashboard/settings/AdminSettingsSearchBox'
import Datetime from 'react-datetime'
  import config from  '../../../config';
import _ from "lodash";



class AdminSettingsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
             showModal: false,
            errors: {},
            sortBy: '',
             currentRecord:{},
            adminSettings:{
                 data: [],
                fetched:false,
                total:0
            }
        };
        this.searchBox = null
    };

    componentWillMount() {

    }


    editRecord(row) {
        var recordCopy = _.cloneDeep(row)
        if (_.includes( row.Name,'ServiceDateRules') ){
            recordCopy.PickupDateRules =_.orderBy(
                _.map(_.get(recordCopy, ['Data', 'Pickup', 'Rules'], []), item=>{
                    return {value:moment(item.Date).format('MM-DD-YYYY'), label: moment(item.Date).format('MM-DD-YYYY')}
                }),  item=>{
                    return item.label
                },[  'asc'])
            recordCopy.DropoffDateRules =_.orderBy(
                _.map(_.get(recordCopy, ['Data', 'Dropoff', 'Rules'], []), item=>{
                    return {value:moment(item.Date).format('MM-DD-YYYY'), label: moment(item.Date).format('MM-DD-YYYY')}
                }),  item=>{
                    return item.label
                },[  'asc'])
        }else if (_.includes(['BoxSettings'],row.Name)){
            recordCopy.boxesList =_.orderBy(
                _.map(_.get(recordCopy, ['Data',  'Rules'], []), item=>{
                    return {...item, _id:uuidv4(), value:item.tag, label:item.tag }
                }),  item=>{
                    return item.label
                },[  'asc'])
        }else if (row.Name.includes('BoxSizeSettings')){
            recordCopy.boxesList =_.orderBy(
              recordCopy.Data.BoxSizeList.map(item => {
                   return {...item,_id:uuidv4() , dimensions:[item.value.Length, item.value.Width, item.value.Height]  }} ),  item=>{
                  return item.label
              },[ 'asc'])
        }else if (row.Name.includes('ServiceSettings')){
            recordCopy.Pickup ={}
            recordCopy.Dropoff ={}
        }
         this.setState({
            showModal: true,
            currentRecord: recordCopy,
        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},
        });
    }





    validateAndGetFormData() {

        var formData = {fieldsToUpdate:[]},            dataNotValid = false;
        if (_.includes( this.state.currentRecord.Name,'ServiceDateRules')){
            formData.fieldsToUpdate.push({
                path:['Pickup','Rules'],
                value:_.map(this.state.currentRecord.PickupDateRules, date=>{
                    return {Date:moment.utc(date.value, 'MM-DD-YYYY').set('hour', 12)   }
                })
            })
            formData.fieldsToUpdate.push({
                path:['Dropoff','Rules'],
                value:_.map(this.state.currentRecord.DropoffDateRules, date=>{
                    return {Date:moment.utc(date.value, 'MM-DD-YYYY').set('hour', 12)   }
                })
            })
        }   else if (_.includes(['BoxSettings'],this.state.currentRecord.Name)) {
            formData.fieldsToUpdate.push({
                path: ['Rules'],
                value: _.orderBy(_.map(this.state.currentRecord.boxesList, item => {
                    return {
                        dimensions: item.dimensions.map(item=>parseFloat(item)),
                        tag: item.value,
                        label: item.dimensions[0] + ' ' + item.dimensions[1] + ' ' + item.dimensions[2]
                    }
                }), item => {
                    return item.tag
                }, ['asc'])
            })
        }else if (this.state.currentRecord.Name.includes('BoxSizeSettings')){
            formData.fieldsToUpdate.push({
                path: ['BoxSizeList'],
                value: _.orderBy(this.state.currentRecord.boxesList.map(item => {
                  const itemDimensions = item.dimensions.map(item=>parseFloat(item))
                    return {
                     // dimensions:itemDimensions,
                      value:{Length:itemDimensions[0], Width:itemDimensions[1], Height:itemDimensions[2]},
                      whole_number_values:item.whole_number_values,
                      selectedBoxTypes:item.selectedBoxTypes,
                      label: item.label
                    }
                }), item => {
                    return item.tag
                }, ['asc'])
            })

        } else if (_.includes( this.state.currentRecord.Name,'ServiceSettings')) {
            if (!_.isUndefined(this.state.currentRecord.Pickup.newFeeAmount)) {
                let {newFeeAmount} = this.state.currentRecord.Pickup

                if (newFeeAmount  == '') {
                    formData.fieldsToUpdate.push({
                        path: ['Pickup', 'FeeAmount'],
                        value: ''
                    })

                } else {
                    newFeeAmount = parseInt(newFeeAmount)
                    if (newFeeAmount < 0 || _.isNaN(newFeeAmount)) {
                        this.props.displayMessage({
                            messageType: 'warning',
                            'messageCode': 'Please specify valid pick-up fee amount',
                        });
                        return false;
                    }
                    formData.fieldsToUpdate.push({
                        path: ['Pickup', 'FeeAmount'],
                        value: newFeeAmount
                    })
                }
            }
            if (!_.isUndefined(this.state.currentRecord.Dropoff.newFeeAmount)) {
                let {newFeeAmount} = this.state.currentRecord.Dropoff

                if (newFeeAmount  == '') {
                    formData.fieldsToUpdate.push({
                        path: ['Dropoff', 'FeeAmount'],
                        value: ''
                    })

                } else {
                    newFeeAmount = parseInt(newFeeAmount)
                    if (newFeeAmount < 0 || _.isNaN(newFeeAmount)) {
                        this.props.displayMessage({
                            messageType: 'warning',
                            'messageCode': 'Please specify valid dropoff fee amount',
                        });
                        return false;
                    }
                    formData.fieldsToUpdate.push({
                        path: ['Dropoff', 'FeeAmount'],
                        value: newFeeAmount
                    })
                }
            }

            if (!_.isUndefined(this.state.currentRecord.Dropoff.newmaximumDaysNumberToAllowBooking)) {
                let {newmaximumDaysNumberToAllowBooking} = this.state.currentRecord.Dropoff
                newmaximumDaysNumberToAllowBooking = parseInt(newmaximumDaysNumberToAllowBooking)

                if (!newmaximumDaysNumberToAllowBooking || _.isNaN(newmaximumDaysNumberToAllowBooking) || newmaximumDaysNumberToAllowBooking<=0) {
                    this.props.displayMessage({
                        messageType: 'warning',
                        'messageCode': 'Please specify valid maximum days number for drop-off booking',
                    });
                    return false;
                }
                formData.fieldsToUpdate.push({
                    path: ['Dropoff', 'maximumDaysNumberToAllowBooking'],
                    value: _.get(this.state.currentRecord.Dropoff, 'newmaximumDaysNumberToAllowBooking')
                })
            }


            if (!_.isUndefined(this.state.currentRecord.Pickup.newmaximumDaysNumberToAllowBooking)) {
                let {newmaximumDaysNumberToAllowBooking} = this.state.currentRecord.Pickup
                newmaximumDaysNumberToAllowBooking = parseInt(newmaximumDaysNumberToAllowBooking)
                if (!newmaximumDaysNumberToAllowBooking || _.isNaN(newmaximumDaysNumberToAllowBooking) || newmaximumDaysNumberToAllowBooking<=0) {
                    this.props.displayMessage({
                        messageType: 'warning',
                        'messageCode': 'Please specify valid maximum days number for pick-up booking',
                    });
                    return false;
                }
                formData.fieldsToUpdate.push({
                    path: ['Pickup', 'maximumDaysNumberToAllowBooking'],
                    value: _.get(this.state.currentRecord.Pickup, 'newmaximumDaysNumberToAllowBooking')
                })

            }
        }
        console.log('formData', dataNotValid, formData);
        if (dataNotValid) {
            return false;
        }
        return formData
    }

    saveRecord() {
        var self = this;
        this.setState({pending: true});
        var formData = this.validateAndGetFormData();
        console.log('formData', formData  );
        if (!formData) {
            this.setState({pending: false});
            return false;
        }
        var methodData = {
            "endpoint": "/settings/" + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
        };

        self.props.makeRequest(formData, methodData).then(recordUpdateResponse => {
            self.setState({pending: false});
              this.props.displayMessage({
                'messageCode': 'Setting record updated',
            });
            self.search()
            self.closeModal()
        }).catch(err => {
            self.setState({pending: false});
        });
    }


    onSortChange(field, sort) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sort == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
         if (this.searchBox) {
            var {queryParams} = this.searchBox.getSearchParams();
        } else {
            var queryParams = {}
        }
        _.extend(queryParams, params);

        queryParams.searchText  ='editable'
        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'Name' + ':' + (-1);
        }

        var methodData = {
            "endpoint": "/settings",
            'not_display_success_message': true,
         };

        if (_.isUndefined(params.doNotUpdateUrlString)) {
            const stringified = queryString.stringify(_.omit(queryParams, ['Names' ]));
            this.context.router.push('/admin/settings?' + stringified);
        }


        return this.props.makeRequest(queryParams, methodData).then(res => {
          this.setState({
              adminSettings:{
                data:res.data.data,
                  total:res.data.total,
                  fetched:true,
            }})

            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                 this.refs.pagination.resetPagination();
            }
        }).catch(err => {
        });
    }
    renderBoxSettingsValues(option) {
         const {currentBoxItem = {}} = this.state.currentRecord

        let itemStyle ={}
        if(currentBoxItem._id == option._id){
            itemStyle.fontWeight ='bold'
        }
        return (
          <div  >
              <div style={itemStyle}>{option.label }</div>
          </div>
        );
    }
    displayBoxSettingsInput(){
      const {currentBoxItem = {}} = this.state.currentRecord
      let disabledCond =  !currentBoxItem.length || !currentBoxItem.width || !currentBoxItem.height
      if( this.state.currentRecord.Name == 'BoxSizeSettings') {
        disabledCond = disabledCond || !currentBoxItem.label
      }
      let displayWholeNumberInputs = false
      console.log('currentBoxItem', currentBoxItem  );
      if((currentBoxItem.length && !Number.isInteger(parseFloat(currentBoxItem.length))) || (currentBoxItem.width && !Number.isInteger(parseFloat(currentBoxItem.width)))
        || (currentBoxItem.height && !Number.isInteger(parseFloat(currentBoxItem.height)))){
        displayWholeNumberInputs = true
      }
        return <div><Row>
            <Col xs={12}  className="">
                <ControlLabel>Boxes</ControlLabel>
                 <Select
                    tabIndex="0"
                    searchable ={true}
                    onValueClick={(option) =>{
                      let currentBoxItemData = {
                        ...option,
                        length:option.dimensions[0],
                        width:option.dimensions[1],
                        height:option.dimensions[2],
                        wholeNumberLength:'',
                        wholeNumberWidth:'',
                        wholeNumberHeight:''
                      }
                      if(option.whole_number_values){
                        currentBoxItemData.wholeNumberLength = option.whole_number_values.Length
                        currentBoxItemData.wholeNumberWidth = option.whole_number_values.Width
                        currentBoxItemData.wholeNumberHeight = option.whole_number_values.Height
                      }
                        this.setState({
                            currentRecord: {
                                ...this.state.currentRecord,
                                currentBoxItem: currentBoxItemData
                            }})
                    }}
                    multi
                    selectedOptions
                    clearable={false}
                    placeholder="Boxes"
                    options={  [] }
                    valueRenderer={this.renderBoxSettingsValues.bind(this)}
                    onChange={ (selectedOptions)=>{
                        this.setState( {currentRecord:{...this.state.currentRecord,
                            boxesList:selectedOptions,
                            currentBoxItem:{length:'', width:'', height:''}
                        }})
                    }}
                    value={ this.state.currentRecord.boxesList}
                />
             </Col>
            </Row>

            <Row className="bot15 ">
                <Col md={4} xs={12} className="top10">
                    <ControlLabel>Length</ControlLabel>
                    <FormControl type="number" min="0" max="80"
                                 onChange={(e) => {
                                     this.setState({
                                         currentRecord: {
                                             ...this.state.currentRecord,
                                             currentBoxItem: {
                                                 ...currentBoxItem,
                                                 length: e.target.value
                                             }
                                         }
                                     })
                                 }}
                                 value={currentBoxItem.length}
                                 placeholder={'Length'}/>
                </Col>


                <Col md={4} xs={12} className="top10">
                    <ControlLabel>Width</ControlLabel>
                    <FormControl type="number" min="0" max="80"
                                 onChange={(e) => {
                                     this.setState({
                                         currentRecord: {
                                             ...this.state.currentRecord,
                                             currentBoxItem: {
                                                 ...currentBoxItem,
                                                 width: e.target.value
                                             }
                                         }
                                     })
                                 }}
                                 value={currentBoxItem.width}
                                 placeholder={'Width'}/>
                </Col>
                <Col md={4} xs={12} className="top10">
                    <ControlLabel>Height</ControlLabel>
                    <FormControl type="number" min="0" max="80"
                                 onChange={(e) => {
                                     this.setState({
                                         currentRecord: {
                                             ...this.state.currentRecord,
                                             currentBoxItem: {
                                                 ...currentBoxItem,
                                                 height: e.target.value
                                             }
                                         }
                                     })
                                 }}
                                 value={currentBoxItem.height}
                                 placeholder={'Height'}/>
                </Col>
              {(this.state.currentRecord.Name == 'BoxSizeSettings' && displayWholeNumberInputs ) &&
                <Row className="bot15 pleft15 pright15">
                  <Col md={4} xs={12} className="top10">
                    <ControlLabel>FeDex Length</ControlLabel>
                    <FormControl type="number" min="0" max="80"
                                 onChange={(e) => {
                                   this.setState({
                                     currentRecord: {
                                       ...this.state.currentRecord,
                                       currentBoxItem: {
                                         ...currentBoxItem,
                                         wholeNumberLength:  e.target.value ? parseInt(e.target.value) : e.target.value,
                                       }
                                     }
                                   })
                                 }}
                                 value={currentBoxItem.wholeNumberLength }
                                 placeholder={'Length'}/>
                  </Col>


                  <Col md={4} xs={12} className="top10">
                    <ControlLabel>FeDex Width</ControlLabel>
                    <FormControl type="number" min="0" max="80"
                                 onChange={(e) => {
                                   this.setState({
                                     currentRecord: {
                                       ...this.state.currentRecord,
                                       currentBoxItem: {
                                         ...currentBoxItem,
                                         wholeNumberWidth: e.target.value ? parseInt(e.target.value) : e.target.value,
                                       }
                                     }
                                   })
                                 }}
                                 value={ currentBoxItem.wholeNumberWidth }
                                 placeholder={'Width'}/>
                  </Col>
                  <Col md={4} xs={12} className="top10">
                    <ControlLabel>FeDex Height</ControlLabel>
                    <FormControl type="number" min="0" max="80"
                                 onChange={(e) => {
                                   this.setState({
                                     currentRecord: {
                                       ...this.state.currentRecord,
                                       currentBoxItem: {
                                         ...currentBoxItem,
                                         wholeNumberHeight: e.target.value ? parseInt(e.target.value) : e.target.value,
                                       }
                                     }
                                   })
                                 }}
                                 value={currentBoxItem.wholeNumberHeight}

                                 placeholder={'Height'}/>
                  </Col>
                </Row>
              }
                { this.state.currentRecord.Name == 'BoxSizeSettings' &&
                  <Col md={6} xs={12} className="top10">
                      <ControlLabel>Label</ControlLabel>
                      <FormControl
                                   onChange={(e) => {
                                       this.setState({
                                           currentRecord: {
                                               ...this.state.currentRecord,
                                               currentBoxItem: {
                                                   ...currentBoxItem,
                                                   label: e.target.value
                                               }
                                           }
                                       })
                                   }}
                                   value={currentBoxItem.label}
                                   placeholder={'Label'}/>
                  </Col>
                }
              { this.state.currentRecord.Name == 'BoxSizeSettings' &&
                <Col md={6} xs={12} className="top10">
                  <ControlLabel>FedEx box type to use</ControlLabel>
                  <Select
                    tabIndex="0"
                    searchable ={true}
                     selectedOptions
                    clearable={false}
                    placeholder=""
                    options={ boxTypes }
                    onChange={ (selectedOption )=>{
                      this.setState({
                        currentRecord: {
                          ...this.state.currentRecord,
                          currentBoxItem: {
                            ...currentBoxItem,
                            selectedBoxTypes:selectedOption ?  [selectedOption] : [],
                          }
                        }
                      })
                    }}
                    value={ currentBoxItem.selectedBoxTypes &&  currentBoxItem.selectedBoxTypes[0] ? currentBoxItem.selectedBoxTypes[0] : null  }
                  />
                </Col>
              }
                <Col   xs={12} className="top10 pright5">
                    <Button className="right10 top10 pull-right  btn btn-primary "
                            disabled={disabledCond}
                            type="button"
                            onClick={() => {
                               const dimensionNotValid =  ['length', 'width', 'height'].find(field=>{
                                    return currentBoxItem[field]  < 0 || currentBoxItem[field]  > 80
                                })
                                if (dimensionNotValid) {
                                    return this.props.displayMessage({
                                        'messageType': 'warning',
                                        'messageCode': `${dimensionNotValid.charAt(0).toUpperCase()}${dimensionNotValid.slice(1)} must be between 0 and 80`,
                                    });
                                }

                              let updatedBoxData = {
                                ...currentBoxItem,
                                dimensions: [currentBoxItem.length, currentBoxItem.width, currentBoxItem.height],
                              }
                                if( this.state.currentRecord.Name == 'BoxSizeSettings'){
                                  if(!currentBoxItem.label) {
                                    return this.props.displayMessage({
                                      'messageType': 'warning',
                                      'messageCode': 'Please, specify box size label',
                                    });
                                  }

                                  if( ( !Number.isInteger(parseFloat(currentBoxItem.length)) ||  !Number.isInteger(parseFloat(currentBoxItem.width)) || !Number.isInteger(parseFloat(currentBoxItem.height))) && (currentBoxItem.wholeNumberLength || currentBoxItem.wholeNumberWidth || currentBoxItem.wholeNumberHeight)  ) {
                                    /* if at least one number includes decimal points, check whole number values */
                                    const dimensionNotValid =  [{value:'wholeNumberLength', label:'length'},
                                      {value:'wholeNumberWidth', label:'width'},
                                      {value:'wholeNumberHeight', label:'height'}].find(item=>{
                                      return currentBoxItem[item.value]  < 0 || currentBoxItem[item.value]  > 80  || !Number.isInteger(currentBoxItem[item.value])
                                    })
                                    if (dimensionNotValid) {
                                      return this.props.displayMessage({
                                        'messageType': 'warning',
                                        'messageCode': `FedEx ${dimensionNotValid.label} must be between 0 and 80`,
                                      });
                                    }
                                    updatedBoxData.whole_number_values = {
                                      Length: currentBoxItem.wholeNumberLength,
                                      Width: currentBoxItem.wholeNumberWidth,
                                      Height: currentBoxItem.wholeNumberHeight
                                    }
                                  }
                                }


                               const foundBox =  this.state.currentRecord.boxesList.find( item=>{
                                   return currentBoxItem._id !== item._id && item.dimensions[0] == currentBoxItem.length && item.dimensions[1] == currentBoxItem.width && item.dimensions[2] == currentBoxItem.height
                               })
                                 if(foundBox){
                                    return this.props.displayMessage({
                                        'messageType': 'warning',
                                        'messageCode': 'Box with dimensions already exists',
                                    });
                                }

                               if(this.state.currentRecord.Name == 'BoxSettings') {
                                   updatedBoxData.value =
                                       updatedBoxData.label = `${currentBoxItem.length} x ${currentBoxItem.width} x ${currentBoxItem.height}`;
                               }else  if( this.state.currentRecord.Name == 'BoxSizeSettings') {
                                     updatedBoxData.label = currentBoxItem.label
                               }
                               let boxSizeListToUpdate
                               if(currentBoxItem._id){
                                   const foundItemIndex = this.state.currentRecord.boxesList.findIndex(item=>item._id == currentBoxItem._id)
                                    console.log('updatedBoxData', updatedBoxData  );

                                   boxSizeListToUpdate= [
                                        ...this.state.currentRecord.boxesList.slice(0, foundItemIndex),
                                        {...updatedBoxData},
                                        ...this.state.currentRecord.boxesList.slice(foundItemIndex + 1)]

                                }else{
                                     boxSizeListToUpdate = this.state.currentRecord.boxesList.concat([{...updatedBoxData, _id:uuidv4()}])
                                 }

                                 this.setState({
                                    currentRecord: {
                                        ...this.state.currentRecord,
                                        boxesList: boxSizeListToUpdate,
                                      currentBoxItem:{length:'', width:'', height:''}
                                    }
                                })

                            }
                            }>
                        {currentBoxItem._id ? 'Edit box' : 'Add box'}
                    </Button>



                </Col>

            </Row>
            </div>

    }

    displayServiceSettingsInput() {
        return <div>
            <ControlLabel className="bot20">Pick-up</ControlLabel>
            <Row className="bot15">
                <Col xs={12} sm={7} className="bot5">
                      Fee Amount
                </Col>
                <Col sm={2}>
                    <FormControl
                      style={{width: 60}}
                      onChange={(e) => {
                          this.setState({
                              currentRecord: {
                                  ...this.state.currentRecord,
                                  Pickup: {
                                      ..._.get(this.state.currentRecord, 'Pickup', {}),
                                      newFeeAmount: e.target.value
                                  }
                              }
                          })
                      }}
                      value={_.get(this.state.currentRecord, 'Pickup.newFeeAmount', _.get(this.state.currentRecord, 'Data.Pickup.FeeAmount', ''))}
                      placeholder={''}/>
                </Col>

            </Row>
            <Row className="bot15">
                <Col xs={12} sm={7} className="bot5">
                    Maximum days number for booking
                </Col>
                <Col xs={12} sm={2} >
                    <FormControl
                      style={{width: 60}}
                      onChange={(e) => {
                          this.setState({
                              currentRecord: {
                                  ...this.state.currentRecord,
                                  Pickup: {
                                      ..._.get(this.state.currentRecord, 'Pickup', {}),
                                      newmaximumDaysNumberToAllowBooking: e.target.value
                                  }
                              }
                          })
                      }}
                      value={_.get(this.state.currentRecord, 'Pickup.newmaximumDaysNumberToAllowBooking', _.get(this.state.currentRecord, 'Data.Pickup.maximumDaysNumberToAllowBooking', ''))}
                      placeholder={''}/>
                </Col>
            </Row>

            <ControlLabel className="bot20">Dropoff</ControlLabel>
            <Row className="bot15">
                <Col xs={12} sm={7}  className="bot5">
                    Fee Amount
                </Col>
                <Col xs={12} sm={2} >
                    <FormControl
                      style={{width:60}}
                      onChange={(e) => {
                          this.setState({
                              currentRecord: {
                                  ...this.state.currentRecord,
                                  Dropoff: {
                                      ..._.get(this.state.currentRecord, 'Dropoff', {}),
                                      newFeeAmount: e.target.value
                                  }
                              }
                          })
                      }}
                      value={_.get(this.state.currentRecord, 'Dropoff.newFeeAmount', _.get(this.state.currentRecord, 'Data.Dropoff.FeeAmount', ''))}
                      placeholder={''}/>
                </Col>
            </Row>
            <Row className="bot15">
                <Col xs={12} sm={7} className="bot5">
                      Maximum days number for booking
                </Col>
                <Col xs={12} sm={2} >
                    <FormControl
                      style={{width: 60}}
                      onChange={(e) => {
                          this.setState({
                              currentRecord: {
                                  ...this.state.currentRecord,
                                  Dropoff: {
                                      ..._.get(this.state.currentRecord, 'Dropoff', {}),
                                      newmaximumDaysNumberToAllowBooking: e.target.value
                                  }
                              }
                          })
                      }}
                      value={_.get(this.state.currentRecord, 'Dropoff.newmaximumDaysNumberToAllowBooking', _.get(this.state.currentRecord, 'Data.Dropoff.maximumDaysNumberToAllowBooking', ''))}
                      placeholder={''}/>
                </Col>
            </Row>
        </div>
    }

    displayDateSelectionInput( ){


                return <Row>
                    <Col xs={12}  md={6} className="top30">
                        <ControlLabel>Drop-off blocked service dates</ControlLabel>
                        <Datetime
                            closeOnSelect={true}
                            dateFormat={'MM-DD-YYYY'} timeFormat={false}
                            onChange={(option) => {
                                console.log('option', option  );

                                this.setState( {currentRecord:{...this.state.currentRecord,
                                    DropoffDateRules:_.orderBy(
                                        _.concat(this.state.currentRecord.DropoffDateRules, {value:moment(option).format('MM-DD-YYYY'), label:moment(option).format('MM-DD-YYYY')}),
                                        item=>{
                                            return moment(item.label,'MM-DD-YYYY')
                                        },[  'asc'])
                                }})
                            }}

                            inputProps={{
                            }}
                            value={null }
                        />
                    </Col>
                    <Col xs={12} className="top10">
                        <Select
                            tabIndex="0"
                            searchable ={true}
                            multi
                            selectedOptions
                            clearable={false}
                            placeholder="Drop-off blocked service dates"
                            options={  [] }
                            onChange={ (selectedOptions)=>{
                                this.setState( {currentRecord:{...this.state.currentRecord,
                                    DropoffDateRules:selectedOptions
                                }})
                            }}
                            value={ this.state.currentRecord.DropoffDateRules}
                        />
                    </Col>


                    <Col xs={12}  md={6} className="top30">
                        <ControlLabel>Pick-up blocked service dates</ControlLabel>
                        <Datetime
                            closeOnSelect={true}
                            dateFormat={'MM-DD-YYYY'} timeFormat={false}
                            onChange={(option) => {
                                 console.log('option', option  );

                                this.setState( {currentRecord:{...this.state.currentRecord,
                                    PickupDateRules:_.orderBy(
                                       _.concat(this.state.currentRecord.PickupDateRules, {value:moment(option).format('MM-DD-YYYY'), label:moment(option).format('MM-DD-YYYY')}),
                                        item=>{
                                             return moment(item.label,'MM-DD-YYYY')
                                        },[  'asc'])
                            }})
                            }}

                            inputProps={{
                                //   placeholder:

                            }}
                            value={null }
                        />
                    </Col>
                    <Col xs={12} className="top10">
                        <Select
                            tabIndex="0"
                            searchable ={true}
                            multi
                            selectedOptions
                            clearable={false}
                            placeholder="Blocked service dates"
                            options={  [] }
                            onChange={ (selectedOptions)=>{
                                this.setState( {currentRecord:{...this.state.currentRecord,
                                    PickupDateRules:selectedOptions
                                }})
                            }}
                             value={ this.state.currentRecord.PickupDateRules}
                        />
                    </Col>
                </Row>
    }
    render() {
       console.log('AdminSettingsPage this state.currentRecord', this.state.currentRecord);

        return (
            <div >
                <AdminSettingsSearchBox
                    ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox;
                            this.search()
                        }
                    } }
                    search={this.search.bind(this)}
                    {...this.props} ></AdminSettingsSearchBox>

                <div className="clearfix"></div>
                {this.state.adminSettings.fetched &&
                <div className="">
                    {this.state.adminSettings.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'records')}</div> :
                        <div className="top10">

                            <AdminSettingsListTable
                                adminSettings={this.state.adminSettings.data}
                                onSortChange={this.onSortChange.bind(this)}
                                 editRecord={this.editRecord.bind(this)}
                                search={this.search.bind(this)} {...this.props}  ></AdminSettingsListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                ref={'pagination'}
                                total={  this.state.adminSettings.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }

                <Modal onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{  'Edit'  }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            {    _.includes(this.state.currentRecord.Name,'ServiceDateRules') && this.displayDateSelectionInput()}
                            {  ['BoxSettings', 'BoxSizeSettings'].includes(this.state.currentRecord.Name) && this.displayBoxSettingsInput()}
                            { _.includes(this.state.currentRecord.Name, 'ServiceSettings') && this.displayServiceSettingsInput()}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary "
                                        disabled={this.state.pending}
                                        type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>


            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
      };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(hot(AdminSettingsPage));
